export const FETCH_COMIC_COLLECTION = 'FETCH_COMIC_COLLECTION'
export const RESET_COMIC_COLLECTION = 'RESET_COMIC_COLLECTION'
